<template>
  <div class="modal-container window">
    <detail-header
        :pcdType="16"
        :formDataObj="formData"
        :isSubmit="isSubmit"
        :isEdit="true"
        @payObj="getPayObj"
        :isLoaded="isLoaded"
        :isHasDo="true"
    ></detail-header>
    <div class="add-box clearfix pay-modal-main">
      <table-header @add="insertEvent" @remove="removeEvent" @copy="copyEvent"></table-header>
      <vxe-table
          border
          show-overflow
          keep-source
          class="table-style produre"
          ref="xTable"
          highlight-hover-row
          max-height="680"
          :data="tableData"
          :edit-rules="editRules"
          :auto-resize="true"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
          @scroll="$refs.xTable.clearValidate()"
          :show-footer="true"
          :footer-method="footerMethod"
          :footer-cell-class-name="footerCellClassName"
      >
        <vxe-table-column width="50" align="center" type="checkbox"></vxe-table-column>
        <vxe-table-column width="60" align="center" field="index" title="序号" v-if="isImport"></vxe-table-column>
        <vxe-table-column type="seq" width="60" align="center" title="序号" v-else></vxe-table-column>
        <vxe-table-column field="payAmount" min-width="130" title="付款金额">
          <template v-slot:header="{ column }">
            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
          </template>
          <template v-slot="{ row }">
            <vxe-input v-model="row.payAmount" type="float" placeholder="输入付款金额"
                       v-on:input="updateFooterEvent()"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column min-width="100" field="note" title="付款摘要">
          <template v-slot="{ row }">
            <vxe-input v-model="row.note" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="recUserName" min-width="150" title="收款人名称">
          <template v-slot:header="{ column }">
            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
          </template>
          <template v-slot="{ row }">
            <vxe-input v-model="row.recUserName" placeholder="请输入收款人名称">
              <template #suffix>
                <Icon style="color: #2d8cf0; font-size: 20px; cursor: pointer" type="ios-list-box-outline"
                      @click="openRecAcc(row)"/>
              </template>
            </vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="recBankAccount" min-width="200" title="收款人银行账号">
          <template v-slot:header="{ column }">
            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
          </template>
          <template v-slot="{ row }">
            <vxe-input v-model="row.recBankAccount" placeholder="请输入收款人银行账号"
                       @change="(file)=>checkBankAccount(file,row)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="recBankName" min-width="200" title="收款人开户银行">
          <template v-slot:header="{ column }">
            <span class="column-title">{{ column.title }} <i style="color: #f00"> * </i></span>
          </template>
          <template v-slot="{ row }">
            <vxe-input v-model="row.recBankName" placeholder="请输入收款人开户银行"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column min-width="150" field="recPhone" title="收款人手机号">
          <template v-slot="{ row }">
            <vxe-input v-model="row.recPhone" placeholder="请输入收款人手机号"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column min-width="150" field="recIdcardNum" title="收款人身份证号码">
          <template v-slot="{ row }">
            <vxe-input v-model="row.recIdcardNum" placeholder="请输入收款人身份证号"></vxe-input>
          </template>
        </vxe-table-column>
      </vxe-table>
      <upload-table ref="uploadTable" style="margin-top: 20px;margin-bottom: 50px;" :row="uploadData[0]"
                    :initFileList="fileList"></upload-table>
      <div class="footer-btn">
        <Button type="primary" @click="impotEvent" v-if="isImport || isCurImport">上传导入文件
        </Button>
        <Button type="primary" @click="submitEvent('new')">提 交</Button>
        <Button type="primary" class="left10" @click="showTempModal" v-if="!isCurImport && !isImport">
          批量导入
        </Button>
        <Button type="primary" class="left10" @click="submitEvent('save')">保存</Button>
      </div>
    </div>
    <vxe-modal v-model="historyModal" title="选择历史收款人" width="1000" height="650" @close="historyModal = false" remember
               destroy-on-close>
      <acc-history @choose="chooseRecHistory" ref="accHistory"></acc-history>
    </vxe-modal>
    <vxe-modal v-model="templateVisible" title="客户付款申请导入" width="1000" height="650" @close="closeTemplate" remember>
      <import @goImport="goImport" @close="closeTemplate" ref="modalTemplate"></import>
    </vxe-modal>
    <vxe-modal v-model="messageVisible" title="消息提示" width="600" height="350" @close="closeMessage" position="center">
      <Message ref="messageModal" @close="closeMessage"></Message>
    </vxe-modal>
  </div>
</template>
<script>
import UploadTable from "@/components/modal/UploadTable";
import DetailHeader from "@/views/procedure/AccPayHeader";
import Message from "@/components/common/Message";
import Import from "@/components/common/Import";
import TableHeader from "@/components/common/TableHeader";
import $api from "@/apiProvider";
import {getExcelTime, hideLoading, isEmpty, isNotEmpty, showFailMsgList, showLoading} from "@/utils/util";
import XLSX from "xlsx";
import {numberToMoney} from "@/filters/type";
import AccHistory from "@/components/proceduremodal/AccHistory";
import {timeFormatDate} from "@/filters/time";

const assign = (o) => Object.assign({}, o);
const empties = [undefined, "", null, "null", {}, []];

export default {
  components: {UploadTable, DetailHeader, TableHeader, Message, Import, AccHistory},
  props: {
    isImport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      historyModal: false,
      tableData: [],
      formData: {},
      isSubmit: false,
      flowTempletId: 16,
      isLoaded: false,
      isCurImport: false,
      messageVisible: false,
      uploadData: [
        {
          fileList: null,
        },
      ],
      fileList: [],
      dataTmp: {
        index: 1,
        payAmount: null,
        note: null,
        recUserName: null,
        recBankAccount: null,
        recBankName: null,
        recPhone: null,
        recIdcardNum: null
      },
      canInsert: true,
      isInitBySave: false,
      templateVisible: false,
      isShow: false,
      editRules: {
        payAmount: [{validator: this.requireValid}],
        recUserName: [{validator: this.requireValid}],
        recBankAccount: [{validator: this.requireValid}],
        recBankName: [{validator: this.requireValid}],
        recPhone: [{validator: this.requireValid}],
        recIdcardNum: [{validator: this.requireValid}],
      },
    }
  },
  watch: {
    isShow: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val === false && oldVal === true) {
          this.$refs[this.tableName].clearValidate();
          this.tableData = [];
          this.canInsert = true;
          this.isSubmit = false;
          this.isLoaded = false;
          this.isCurImport = false;
        }
        if (val === true && !this.isInitBySave) {
          this.insertEvent();
          let id = 16;
          this.getFlowData(id);
        }
      },
    },
  },
  computed: {
    tableName() {
      return "xTable";
    },
  },
  created() {
    this.isShow = true;
  },
  mounted() {
    document.title = '客户付款申请';
    if (this.$route.params.flowId) {
      this.initBySave(this.$route.params.flowId);
    }
  },
  methods: {
    checkBankAccount(e, row) {
      row.recBankAccount = e.value.replace(/[^\d]/g, '');
    },
    async initBySave(id) {
      this.isInitBySave = true;
      this.initBySaveId = id;
      $api.flowInstance.queryDraftFlowDetail
          .GET({
            params: {
              id,
            },
          })
          .then((res) => {
            if (res.status === 1) {
              this.flowTempletId = res.data.templetType;
              document.title = res.data.instanceName;
              this.formData = Object.assign(res.data, {});
              this.isLoaded = true;
              this.fileList = res.data.attachFile;
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error",
              });
            }
          });
      let params = {
        page: 1,
        rows: 10000,
        orderBy: 2,
        isDesc: 0,
        flowId: id,
      };
      // 开票
      let resData = await $api.twoPayments.request("queryClientPayApplyList", params);
      if (resData.status === 1) {
        this.tableData = resData.data.list;
      }
    },
    async validEvent() {
      const errMap = await this.$refs[this.tableName].validate().catch((errMap) => errMap);
      return errMap ? false : true;
    },
    async submitEvent(type = "new") {
      this.isSubmit = true;
      if (type === "new") {
        if (isEmpty(this.formData.compName)) {
          this.$XModal.message({status: "error", message: "请选择所属公司"});
          return
        }
        if (isEmpty(this.formData.salesManId)) {
          this.$XModal.message({status: "error", message: "请选择业务员"});
          return
        }
        if (isEmpty(this.formData.reterence)) {
          this.$XModal.message({status: "error", message: "审批人不能为空"});
          return
        }

        let sts = await this.validEvent();
        if (!sts) {
          this.$XModal.message({
            status: "error",
            message: "校验不通过！",
          });
          return;
        }
      }

      let table = this.$refs[this.tableName].getTableData();

      if (table.tableData.length === 0) {
        this.$XModal.message({
          message: "请先添加付款记录",
        });
        return;
      }

      let map = {};
      let check = false;

      table.tableData.some(i => {
        if (map[i.recBankAccount]) {
          let value = map[i.recBankAccount];
          if (value.recUserName !== i.recUserName || value.recBankName !== i.recBankName || value.recPhone !== i.recPhone || value.recIdcardNum !== i.recIdcardNum) {
            this.$XModal.message({
              message: "序列号" + value.index + '与' + i.index + ':收款人信息不一致',
            });
            check = true;
            return true;
          }
        } else {
          map[i.recBankAccount] = i;
        }
      })

      if (check) return;

      let obj = {};
      let rows = [];
      table.fullData.forEach((item) => {
        let row = assign(item);
        rows.push(row);
      });
      obj.attachFile = this.uploadData[0].fileUuidList;
      obj.applyTime = this.$utils.timestamp(this.$utils.toStringDate(this.formData.applyTime));
      obj.instanceName = this.formData.instanceName;
      obj.instanceNum = this.formData.instanceNum;
      obj.applyUserId = this.formData.applyUserId;
      obj.leaderId = this.formData.leaderId;
      obj.managerId = this.formData.managerId;
      obj.reterenceId = this.formData.reterenceId;
      obj.reterenceName = this.formData.reterence;
      obj.flowTempletId = this.flowTempletId;
      obj.compName = this.formData.compName;
      obj.platformCompanyId = this.formData.platformCompanyId;
      obj.note = this.formData.note;
      obj.salesMan = this.formData.salesMan;
      obj.salesManId = this.formData.salesManId;

      obj.list = rows;
      if (this.isInitBySave) {
        obj.id = this.initBySaveId;
      }
      let action = "";
      if (type === "new") {
        action = "saveFlowForClientPayApply"
      } else {
        action = "saveDraftFlowForClientPayApply"
      }
      let msgTxt = type === "new" ? "提交成功" : "保存成功";
      this.commitObj = obj;
      showLoading();
      let res = await $api.flowInstance.request(action, obj);
      hideLoading();

      if (res.status === 1) {
        this.$XModal.message({
          status: "success",
          message: msgTxt,
        });
        this.tableData = [];
        this.$emit("close");
        window.close();
      } else if (res.status === 0) {
        if (isNotEmpty(res.data)) {
          showFailMsgList(res.data);
        } else {
          this.$XModal.message(res.message);
        }
      } else if (res.status === -1) {
        let data = res.data;
        let message = "";
        if (data.length > 0) {
          data.map(i => {
            message = message + "序号" + (this.tableData[i.failArrayIndex].index - 1) + "，" + i.failMsg + "\n";
          });
        }
        this.$refs.messageModal.setMessage(message);
        this.messageVisible = true;
      } else {
        if (!res.message) {
          res.message = "接口异常";
        }
        this.$XModal.message(res.message);
      }
      this.$emit("init");
    },
    async requireValid(e) {
      if (e.column.title === '收款人手机号' && isNotEmpty(e.row.recPhone)) {
        let regPhone = new RegExp(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/);
        let validPhone = regPhone.test(e.row.recPhone);
        if (!validPhone) {
          return Promise.reject(new Error('收款人手机号错误'))
        }
      }
      if (e.column.title === '收款人身份证号码' && isNotEmpty(e.row.recIdcardNum)) {
        let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
        let validIDre = _IDRe18.test(e.row.recIdcardNum) || _IDre15.test(e.row.recIdcardNum);
        if (!validIDre) {
          return Promise.reject(new Error('收款人身份证号码错误'))
        }
      }
      if (e.column.title !== '收款人手机号' && e.column.title !== '收款人身份证号码' && empties.includes(e.cellValue)) {
        return Promise.reject(new Error(e.column.title + "必填"));
      }
    },
    openRecAcc(row) {
      this.currentRow = row;
      this.historyModal = true;
      this.$nextTick(() => {
        this.$refs.accHistory.init();
      })
    },
    chooseRecHistory(row) {
      this.currentRow.recUserName = row.recUserName;
      this.currentRow.recPhone = row.recPhone;
      this.currentRow.recBankAccount = row.recBankAccount;
      this.currentRow.recBankName = row.recBankName;
      this.currentRow.recIdcardNum = row.recIdcardNum;
      this.historyModal = false;
    },
    footerMethod({columns, data}) {
      // 底部合计
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) {
            return "合计";
          }
          if (["payAmount"].includes(column.property)) {
            return numberToMoney(this.$utils.sum(data, column.property));
          }
          return null;
        })
      ];
    },
    updateFooterEvent() {
      this.$refs[this.tableName].updateFooter();
    },
    footerCellClassName({$rowIndex, column, columnIndex}) {
      return "footer-cell";
    },
    showTempModal() {
      this.$refs.modalTemplate.setExport("客户付款申请-0327.xls");
      this.templateVisible = true;
    },
    closeTemplate() {
      this.templateVisible = false;
    },
    goImport() {
      this.impotEvent();
      this.templateVisible = false;
    },
    async impotEvent() {
      this.$refs[this.tableName]
          .readFile({
            types: ["xls", "xlsx"],
          })
          .then(async (evnt) => {
            showLoading();
            const tableData = [];
            const importIds = [];
            const files = evnt.target.files;
            const fileReader = new FileReader();
            fileReader.onload = async (ev) => {
              const data = ev.target.result;
              const workbook = XLSX.read(data, {
                type: "binary",
              });
              const csvData = XLSX.utils.sheet_to_csv(Object.values(workbook.Sheets)[0]);
              // 解析数据
              if (csvData.split("\n").length > 302) {
                hideLoading();
                this.$XModal.alert({
                  message: "本次导入数据超过300条",
                  status: "error",
                });
                return
              }
              csvData.split("\n").forEach((vRow, index) => {
                if (vRow && index > 0) {
                  const vCols = vRow.split(",");
                  let item = {
                    index: index + 1, //需要
                    payAmount: vCols[1].toString().match(/^\d+(?:\.\d{0,2})?/),
                    note: vCols[2],
                    recUserName: vCols[3],
                    recBankAccount: vCols[4].replace(/[^\d]/g, ''),
                    recBankName: vCols[5],
                    recPhone: vCols[6],
                    recIdcardNum: vCols[7]
                  };

                  tableData.push(item);
                }
                this.tableData = tableData;
              });
              setTimeout(() => {
                hideLoading();
              }, 1000);
            }
            fileReader.readAsBinaryString(files[0]);
          });
    },
    closeMessage() {
      this.messageVisible = false;
    },
    getPayObj(val) {
      this.formData = val;
    },
    getFlowData(id) {
      let obj = {
        flowTempletId: id,
      };
      this.flowTempletId = id;
      $api.flowInstance.createFlowModel
          .GET({
            params: obj,
          })
          .then((res) => {
            if (res.status === 1) {
              this.formData = res.data;
              document.title = res.data.instanceName;
              this.isLoaded = true;
            } else {
              this.$XModal.confirm(res.message).then(() => {
                window.close();
              });
            }
          });
    },
    insertEvent() {
      let tableData = this.$refs[this.tableName].getTableData().tableData;
      this.$refs[this.tableName].clearValidate();
      let record = assign(this.dataTmp);
      record.index = tableData.length + 1;
      record.fileList = [];
      record.fileUuidList = [];
      this.$refs[this.tableName].insertAt(record, -1);
    },
    async removeEvent() {
      let checkboxRecords = this.$refs[this.tableName].getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择",
        });
        return;
      }
      if (!this.canInsert) {
        //不能全部删除
        if (checkboxRecords.length === this.$refs[this.tableName].getTableData().tableData.length) {
          this.$XModal.message({
            message: "不能全部删除,至少保留一条",
          });
          return;
        }
      }
      let confirmRes = await this.$XModal.confirm("删除后不可恢复", "是否删除？");
      if (confirmRes === "confirm") {
        this.$refs[this.tableName].removeCheckboxRow();
      }
    },
    copyEvent() {
      let checkboxRecords = this.$refs[this.tableName].getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择",
        });
        return;
      }

      this.$refs[this.tableName].insertAt(checkboxRecords, -1);
    },
  }
}

</script>
<style>
.window {
  padding: 20px;
  background: #ffffff;
  height: 100vh;
}

.pay-modal-main {
  padding-top: 20px;
}
</style>
<style scoped>
.add-box .produre .vxe-input, .add-box .produre .vxe-select, .add-box .produre .ivu-cascader .ivu-input {
  height: 30px;
}

.produre .vxe-select >>> .vxe-input {
  height: 30px;
}

.produre >>> .vxe-body--column {
  height: 30px !important;
}

.produre >>> .vxe-body--column:not(.col--ellipsis), .produre >>> .vxe-footer--column:not(.col--ellipsis), .produre >>> .vxe-header--column:not(.col--ellipsis) {
  padding: 3px 0;
}

.footer-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  overflow: hidden;
  vertical-align: middle;
  background-color: #fff;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 15px;
  display: flex;
  justify-content: flex-end;
}

.left10 {
  margin-left: 10px;
}
</style>